import axios from 'axios'
import router from '../router'
import store from '@/store/store'
import { Base64 } from 'js-base64';

const apiClient = axios.create({
  baseURL:
    process.env.VUE_APP_HEROKU_API_BASE_URL || process.env.VUE_APP_APIPATH,
  withCredentials: true, // This is the default
  timeout: 20000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  setLocale(locale) {
    if (locale == null || locale.length < 2) {
      locale = 'de'
    }
    apiClient.post('/locale', { locale: locale.substring(0, 2) })
  },

  // Fair wall handling.
  createFairWallEntry(data) {
    return apiClient.post('/fairwallentry', data).catch(this.globalErrorHandler)
  },
  updateFairWallEntry(data) {
    return apiClient
      .put('/fairwallentry/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteFairWallEntry(id) {
    return apiClient
      .delete('/fairwallentry/' + id)
      .catch(this.globalErrorHandler)
  },
  getFairWallEntries() {
    return apiClient.get('/fairwallentry').catch(this.globalErrorHandler)
  },
  getFairWallEntry(id) {
    return apiClient.get('/fairwallentry/' + id).catch(this.globalErrorHandler)
  },
  getCurrentFairWallEntries(amount) {
    if (amount == undefined) {
      return apiClient
        .get('/currentfairwallentries')
        .catch(this.globalErrorHandler)
    } else {
      return apiClient
        .get('/currentfairwallentries/' + amount)
        .catch(this.globalErrorHandler)
    }
  },

  // Fair states
  getFairStates() {
    return apiClient.get('/fairstates').catch(this.globalErrorHandler)
  },

  // Task definition handling.
  createTaskDefinition(data) {
    return apiClient
      .post('/taskdefinition', data)
      .catch(this.globalErrorHandler)
  },
  updateTaskDefinition(data) {
    return apiClient
      .put('/taskdefinitions/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteTaskDefinition(id) {
    return apiClient
      .delete('/taskdefinitions/' + id)
      .catch(this.globalErrorHandler)
  },
  getTaskDefinitions() {
    return apiClient.get('/taskdefinitions').catch(this.globalErrorHandler)
  },
  getTaskDefinition(id) {
    return apiClient
      .get('/taskdefinitions/' + id)
      .catch(this.globalErrorHandler)
  },
  getTaskDefinitionsInFairs() {
    return apiClient
      .get('/taskdefinitionsInFairs')
      .catch(this.globalErrorHandler)
  },

  // Header definition handling.
  createHeaderDefinition(data) {
    return apiClient
      .post('/headerdefinition', data)
      .catch(this.globalErrorHandler)
  },
  updateHeaderDefinition(data) {
    return apiClient
      .put('/headerdefinitions/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteHeaderDefinition(id) {
    return apiClient
      .delete('/headerdefinitions/' + id)
      .catch(this.globalErrorHandler)
  },
  getHeaderDefinitions() {
    return apiClient.get('/headerdefinitions').catch(this.globalErrorHandler)
  },
  getHeaderDefinition(id) {
    return apiClient
      .get('/headerdefinitions/' + id)
      .catch(this.globalErrorHandler)
  },

  // Fair handling.
  getFairs() {
    return apiClient
      .get('/fairs')
      .then(fairs => {
        fairs.data.forEach(fair => {
          this.fixdata(fair)
        })
        return fairs
      })
      .catch(this.globalErrorHandler)
  },
  getFairsWithTasks() {
    return apiClient.get('/fairsWithTasks').catch(this.globalErrorHandler)
  },
  getFair(id) {
    return apiClient
      .get('/fairs/' + id)
      .then(data => this.stringifyData(data))
      .then(data => {
        var images = ['logo', 'logoDe', 'logoEn', 'logoFr']
        for (var iKey in images) {
          if (data.data[images[iKey]] === undefined) {
            data.data[images[iKey]] = null
          }
        }
        return data
      })
      .catch(this.globalErrorHandler)
  },
  createFair(data) {
    return apiClient.post('/fair', data).catch(this.globalErrorHandler)
  },
  updateFair(data) {
    return apiClient
      .put('/fairs/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteFair(id) {
    return apiClient.delete('/fairs/' + id).catch(this.globalErrorHandler)
  },
  updateFairDocs(data) {
    return apiClient.post('/fairdocs', data)
  },

  // Fair Insurance handling
  getInsurance(boothId = '') {
    return apiClient.get('/insurance/' + boothId).catch(this.globalErrorHandler)
  },
  createInsurance(boothId = '', data = {}) {
    return apiClient
      .post('/insurance/' + boothId, data)
      .catch(this.globalErrorHandler)
  },
  updateInsurance(boothId = '', data = {}) {
    return apiClient
      .put('/insurance/' + boothId, data)
      .catch(this.globalErrorHandler)
  },
  deleteInsurance(boothId = '') {
    return apiClient
      .post('/insurance/' + boothId)
      .catch(this.globalErrorHandler)
  },

  // Teaser handling
  getTeasersOverview() {
    return apiClient
      .get('/teasersOverview')
      .catch(this.globalErrorHandler)
      .catch(this.globalErrorHandler)
  },
  getTeaser(id) {
    return apiClient
      .get('/teasers/' + id)
      .then(data => this.stringifyData(data))
      .then(data => {
        var images = [
          'imageLandscapeDe',
          'imagePortraitDe',
          'imageLandscapeFr',
          'imagePortraitFr',
          'imageLandscapeEn',
          'imagePortraitEn',
          'imageLandscapeDe2',
          'imagePortraitDe2',
          'imageLandscapeFr2',
          'imagePortraitFr2',
          'imageLandscapeEn2',
          'imagePortraitEn2',
          'imageLandscapeDe3',
          'imagePortraitDe3',
          'imageLandscapeFr3',
          'imagePortraitFr3',
          'imageLandscapeEn3',
          'imagePortraitEn3'
        ]
        for (var iKey in images) {
          if (data.data[images[iKey]] === undefined) {
            data.data[images[iKey]] = null
          }
        }
        return data
      })
      .catch(this.globalErrorHandler)
  },
  checkTeaserDateRange(data) {
    return apiClient
      .post('/checkTeaserDateRange', data)
      .catch(this.globalErrorHandler)
  },
  getTeaserOfType(type, user, fair, boothId, tasksDone, boothState, uuid) {
    // TODO: Replace with correct logic, to load random teaser of "type"
    return new Promise(resolve => {
      apiClient
        .post('/teaseroftype', {
          type: type,
          user: user,
          fair: fair,
          tasksDone: tasksDone,
          boothState: boothState,
          uuid: uuid,
          boothId: boothId
        })
        .then(teaserResponse => {
          resolve(this.stringifyData(teaserResponse))
        })
        .catch(this.globalErrorHandler)
    })
  },
  getTeaserTypes() {
    return apiClient.get('/teasertypes').catch(this.globalErrorHandler)
  },
  createTeaser(data) {
    return apiClient.post('/teaser', data).catch(this.globalErrorHandler)
  },
  deleteTeaser(id) {
    return apiClient.delete('/teaser/' + id).catch(this.globalErrorHandler)
  },
  updateTeaser(data) {
    return apiClient
      .put('/teasers/' + data._id, data)
      .catch(this.globalErrorHandler)
  },

  // FairSeries handling
  getFairSeries() {
    return apiClient.get('/fairseries').catch(this.globalErrorHandler)
  },
  getFairSeriesInFairs() {
    return apiClient.get('/fairseriesInFairs').catch(this.globalErrorHandler)
  },
  getFairSeriesById(id) {
    return apiClient.get('/fairseries/' + id).catch(this.globalErrorHandler)
  },
  createFairSeries(data) {
    return apiClient.post('/fairseries', data).catch(this.globalErrorHandler)
  },
  updateFairSeries(data) {
    return apiClient
      .put('/fairseries/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteFairSeries(id) {
    return apiClient.delete('/fairseries/' + id).catch(this.globalErrorHandler)
  },

  // TaskTitle handling
  getTaskTitles() {
    return apiClient.get('/tasktitles').catch(this.globalErrorHandler)
  },
  getTaskTitle(id) {
    return apiClient.get('/tasktitle/' + id).catch(this.globalErrorHandler)
  },
  createTaskTitle(data) {
    return apiClient.post('/tasktitle', data).catch(this.globalErrorHandler)
  },
  updateTaskTitle(data) {
    return apiClient
      .put('/tasktitle/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteTaskTitle(id) {
    return apiClient.delete('/tasktitle/' + id).catch(this.globalErrorHandler)
  },
  getTaskTitlesInFairs() {
    return apiClient.get('/tasktilesInFairs').catch(this.globalErrorHandler)
  },
  getBoothServices() {
    return apiClient.get('/boothservices').catch(this.globalErrorHandler)
  },
  getBoothService(id) {
    return apiClient.get('/boothservice/' + id).catch(this.globalErrorHandler)
  },
  createBoothService(data) {
    return apiClient.post('/boothservice', data).catch(this.globalErrorHandler)
  },
  updateBoothService(data) {
    return apiClient
      .put('/boothservice/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteBoothService(id) {
    return apiClient
      .delete('/boothservice/' + id)
      .catch(this.globalErrorHandler)
  },

  // Step tracking
  setCurrentStep(regiNr, task, boothLabel, boothArea, fairId) {
    return apiClient
      .post('/stepTracker', {
        regiNr: regiNr,
        task: task,
        boothLabel,
        boothArea,
        fairId
      })
      .catch(this.globalErrorHandler)
  },

  getBlacklistOverview() {
    return apiClient.get('/blacklistOverview').catch(this.globalErrorHandler)
  },
  getBlacklist(id) {
    return apiClient.get('/blacklist/' + id).catch(this.globalErrorHandler)
  },
  createBlacklist(data) {
    return apiClient.post('/blacklist', data).catch(this.globalErrorHandler)
  },
  updateBlacklist(data) {
    return apiClient
      .put('/blacklist/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  deleteBlacklist(id) {
    return apiClient.delete('/blacklist/' + id).catch(this.globalErrorHandler)
  },

  // TaskNotification handling
  updateTaskNotificationState(data) {
    return apiClient.post('/booth/setNotificationState', data)
  },

  // Notifications
  getNotifications() {
    return apiClient.get('/notifications/').catch(this.globalErrorHandler)
  },
  setNotificationRead(id) {
    return apiClient
      .get('/notificationread/' + id)
      .catch(this.globalErrorHandler)
  },

  // User handling
  getUser(id) {
    return apiClient.get('/user/' + id).catch(this.globalErrorHandler)
  },
  createUser(data) {
    return apiClient.post('/user', data).catch(this.globalErrorHandler)
  },
  updateUser(data) {
    return apiClient
      .put('/user/' + data._id, data)
      .catch(this.globalErrorHandler)
  },
  getRolesForUser(id) {
    return apiClient.get('/userroles/' + id).catch(this.globalErrorHandler)
  },
  setMailNotifications(user, mailNotificationState) {
    return apiClient.post('/user/setmailnotifications', {
      user: user,
      mailNotifications: mailNotificationState
    })
  },
  getMailNotifications(user) {
    return apiClient.post('/user/setmailnotifications', {
      user: user,
      mailNotifications: true
    })
  },
  setAccessToken(token) {
    return apiClient
      .post('/setAccessToken', { token: token })
      .catch(this.globalErrorHandler)
  },

  // RUBIN
  async getRubinBooth(id) {
    return apiClient.get('/rubin/booth/' + id)
  },
  async getRubinBoothCost(id) {
    return apiClient.get('/rubin/boothcost/' + id)
  },
  async getRubinServiceShopLink(id, shop, service, lang) {
    return apiClient.get(`/rubin/serviceshop/${id}/${shop}/${service}/${lang}`)
  },
  async getRubinOrderExisting(id, service) {
    return apiClient.get(`/rubin/orderexists/${id}/${service}`)
  },
  async getRubinBoothLinks(id) {
    return apiClient.get('/rubin/boothlinks/' + id)
  },
  async getRubinBoothAddress(id) {
    return apiClient.get('/rubin/address/' + id)
  },
  getRubinBoothDocuments(id) {
    return apiClient.get('/rubin/boothdocuments/' + id)
  },
  getRubinPastBoothDocuments(id) {
    return apiClient.get('/rubin/pastboothdocuments/' + id)
  },
  getDocumentContent(id) {
    return apiClient.get('/rubin/documentcontent/' + id)
  },
  async getRubinFairsWithBooths() {
    if (this.isNewMember()) {
      return []
    }
    let fairs = await apiClient
      .get('/rubin/fairs')
      .catch(this.globalErrorHandler)

    await new Promise((resolve, reject) => {
      let fairsDone = 0
      if (fairs && fairs.hasOwnProperty('data')) {
        if (fairs.data.name !== undefined && fairs.data.name === 'Error') {
          reject()
          return
        }
        let fairsData = fairs.data;
        if (!(fairsData instanceof Array)) {
          fairsData = [];
        }
        if (fairsData.length === 0) {
          resolve();
        }
        fairsData.forEach(fair => {
          this.fixdata(fair)

          fair.booths = []
          apiClient
            .get('/rubin/fair/booths/' + fair.idCode)
            .then(anmeldungen => {
              let boothsDone = 0

              if (anmeldungen.data.standanmeldungen !== undefined) {
                anmeldungen.data.standanmeldungen.forEach(booth => {
                  booth.regiNr = booth.standanmeldungId
                  fair.booths.push(booth)
                })
              }
              fairsDone++
              if (fairsDone === fairsData.length) {
                resolve()
              }
            })
        })
      }
    })
    return fairs
  },

  // helpers
  stringifyData(obj) {
    this.fixdata(obj.data)
    return obj
  },
  fixdata(obj) {
    for (var key in obj) {
      if (
        typeof obj[key] === 'object' &&
        obj[key] !== null &&
        obj[key].type === 'Buffer'
      ) {
        var str = ''
        for (var i = 0; i < obj[key].data.length; i++) {
          str += String.fromCharCode(obj[key].data[i])
        }
        obj[key] = str
      }
    }
  },
  globalErrorHandler: err => {
    if (
      err.response !== undefined &&
      (err.response.status === 403 || err.response.status === 401)
    ) {
      console.log("GOT error: " + err.response.status)
      //not allowed - log out!
      router.push('/logout')
    } else {
      console.log("GOT error: " + err.response.status)
      store.dispatch('setMessage', 'errors.apiError')
      router.push({ name: 'Home' }).catch(err => {})
    }
  },

  // Registration handling.
  isNewMember() {
    if (store.getters['oidcAccessToken']) {
      const parts = store.getters['oidcAccessToken'].split('.')
      if (parts.length === 3) {
        let obj = JSON.parse(Base64.decode(parts[1]))
        if (
          obj.realm_access !== undefined &&
          obj.realm_access.roles !== undefined
        ) {
          if (
            obj.realm_access.roles.indexOf('MITAUSSTELLER') > -1 ||
            obj.realm_access.roles.indexOf('AUSSTELLER') > -1
          ) {
            return false
          }
        }
      }
    }
    return true
  }
}
